var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1651 18.5654C14.699 18.6975 14.2755 18.9599 13.9853 19.3479L12.4 21.4667C12.2 21.7333 11.8 21.7333 11.6 21.4667L10.0147 19.3479C9.72449 18.9599 9.301 18.6975 8.83489 18.5654C4.86329 17.4399 2 14.2542 2 10.5C2 5.80558 6.47715 2 12 2C17.5228 2 22 5.80558 22 10.5C22 14.2542 19.1367 17.4399 15.1651 18.5654ZM8 8.25C7.58579 8.25 7.25 8.58579 7.25 9C7.25 9.41421 7.58579 9.75 8 9.75H16C16.4142 9.75 16.75 9.41421 16.75 9C16.75 8.58579 16.4142 8.25 16 8.25H8ZM10 12.25C9.58579 12.25 9.25 12.5858 9.25 13C9.25 13.4142 9.58579 13.75 10 13.75H14C14.4142 13.75 14.75 13.4142 14.75 13C14.75 12.5858 14.4142 12.25 14 12.25H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble21);
export default __webpack_public_path__ + "static/media/speech-bubble-21.7933a0026331d44d1f0d33006fd993ba.svg";
export { ForwardRef as ReactComponent };